import store from "reduxStore";
import { getUserIdToken } from "../../service/firebase/auth";
import { getClientByEmail} from "../../api/paymentManagement/restfulApi";
import { AxiosInstance,AxiosInstance_V2, AxiosMember } from "../../api/paymentManagement/client";

const setDomainInfo = (value) => store.dispatch({
  type: "SET_DOMAIN_INFO",
  value,
});

const setCurrencies = (currencies) => {
  store.dispatch({
    type: "SET_CURRENCIES",
    currencies,
  })
};

const setTransCurrency = (currencyId) => {
  store.dispatch({
    type: "SET_TRANS_CURRENCY",
    currencyId,
  })
};

const setTemplateByRedux = (value) => {
  store.dispatch({
    type: "SET_TEMPLATE",
    value,
  })
};

function setUserAction(value) {
  return {
    type: "SET_USER",
    value,
  };
}

const setNotify = (value) => store.dispatch({
  type: "SET_NOTIFY",
  value,
});


const fetchClient = async(email) => {
  const result = await getClientByEmail(email)
  return result.data
}


const setUser = async (role, email="") => {
  const idToken = await getUserIdToken();

  AxiosInstance.defaults.headers.common['Authorization'] = idToken
  AxiosInstance_V2.defaults.headers.common['Authorization'] = idToken
  AxiosMember.defaults.headers.common['Authorization'] = idToken

  if (role === "client") {
    if (email) {
      const clientData = await fetchClient(email)
      store.dispatch(setUserAction({
        role: "client",
        clientInfo:clientData
      }))

    }
    else {
      store.dispatch(setUserAction({
        role: "client",
        clientInfo: {}
      }))
    }
  }
  else {
    store.dispatch(setUserAction(""))
    delete AxiosInstance.defaults.headers.common['Authorization']
    delete AxiosMember.defaults.headers.common['Authorization']
  }
};

function setStylesAction(value) {
  return {
    type: "SET_STYLES",
    value,
  };
} 


const  setStyles = (styles) => store.dispatch(setStylesAction(styles));

function setLoginAction(value) {
  return {
    type: "SET_LOGIN",
    value,
  };
}

const setLogin = (data) => store.dispatch(setLoginAction(data));


const setMerchantInfoByRedux = (value) =>
  store.dispatch({
    type: "SET_MERCHANTINFO",
    value,
  });

const setStore = (payload) =>
  store.dispatch({
    type: "SET_STORE",
    payload,
  });

const setSelectedComs = (data) => store.dispatch(setSelectedComsAction(data));

function setSelectedComsAction(value) {
  return {
    type: "SET_SELECTED_COMS",
    value,
  };
}

const setDynamicComs = (data) => store.dispatch(setDynamicComsAction(data));

function setDynamicComsAction(value) {
  return {
    type: "SET_DYNAMIC_COMS",
    value,
  };
}

const showLoginPop = (condition) =>
  store.dispatch({ type: condition ? "SHOW_POPUP" : "CLOSE_POPUP" });

const setIsLoading = (payload) => {
  console.log("setIsLoading payload", payload);
  const type = payload?.text ? "IS_LOADING_TEXT" : (payload ? "IS_LOADING" : "NOT_LOADING")
  
  store.dispatch({type,payload  });
};

function setTransactionAction(value) {
  return {
    type: "SET_TRAN",
    value,
  };
}
const setTranByRedux = (data) => store.dispatch(setTransactionAction(data));

/**
 * Show alert modal and set the message.
 * @param {Object|string} message
 * @param {string} [message.title]
 * @param {string} [message.body]
 * @param {function} [message.onHide]
 * @param {int} [message.animationType] :
 *  0: no animation,
 *  1: success animation,
 */
const alertMessage = (
  message = {
    title: "",
    body: "",
    onHide: null,
    animationType: 1,
  }
) => {
  const payload = { title: "", body: "", onHide: null };
  if (typeof message === "string") {
    payload.body = message;
  } else {
    payload.title = message.title;
    payload.body = message.body;
    payload.onHide = message.onHide;
    payload.animationType =
      message.animationType || message.animationType === 0
        ? message.animationType
        : 1;
  }
  store.dispatch({ type: "SHOW_MESSAGE", payload });
};

/**
 * Hide alert modal.
 */
const hideAlertMessage = () => store.dispatch({ type: "HIDE_MESSAGE" });

/**
 * Set browsing device
 * @param {String} value MOBILE or PC or TABLET
 */
const setDevice = (value) => {
  store.dispatch({ type: value });
};



export {
  setDomainInfo,
  setCurrencies,
  setTransCurrency,
  setUser,
  setLogin,
  setMerchantInfoByRedux,
  setStore,
  setSelectedComs,
  setDynamicComs,
  setIsLoading,
  showLoginPop,
  alertMessage,
  hideAlertMessage,
  setTranByRedux,
  setDevice,
  // setMerchant,
  setStyles,
  setNotify,
  setTemplateByRedux
};
